import {
  SET_PDF_FORM_TEMPLATES,
  SET_PDF_FORM_TEMPLATE,
  SET_PDF_FORM_FIELDS,
  FETCHING_PDF_FORM_TEMPLATES,
  PDF_FORM_TEMPLATE_CREATED,
  PDF_FORM_TEMPLATE_DELETED,
  PDF_FORM_FIELDS_SAVED,
  SET_PDF_FORM_SUBMISSIONS,
  SET_PDF_FORM_SUBMISSION,
  PDF_FORM_SUBMISSION_CREATED,
  PDF_FORM_SUBMISSION_EMAILED,
  PDF_FORM_SUBMISSION_DELETED,
  pdfFormTemplatesActionTypes,
} from './actions';

const initialState = {
  templates: [],
  template: undefined,
  fields: [],
  fetching: false,
  templateCreated: false,
  templateDeleted: false,
  fieldsSaved: false,
  submissions: [],
  submission: undefined,
  submissionCreated: false,
  submissionEmailed: false,
  submissionDeleted: false,
};

export const pdfFormTemplatesReducer = (state = initialState, action: pdfFormTemplatesActionTypes) => {
  const { type, payload } = action;
  switch (type) {
    case SET_PDF_FORM_TEMPLATES:
      return { ...state, templates: payload };
    case SET_PDF_FORM_TEMPLATE:
      return { ...state, template: payload };
    case SET_PDF_FORM_FIELDS:
      return { ...state, fields: payload };
    case FETCHING_PDF_FORM_TEMPLATES:
      return { ...state, fetching: payload };
    case PDF_FORM_TEMPLATE_CREATED:
      return { ...state, templateCreated: payload };
    case PDF_FORM_TEMPLATE_DELETED:
      return { ...state, templateDeleted: payload };
    case PDF_FORM_FIELDS_SAVED:
      return { ...state, fieldsSaved: payload };
    case SET_PDF_FORM_SUBMISSIONS:
      return { ...state, submissions: payload };
    case SET_PDF_FORM_SUBMISSION:
      return { ...state, submission: payload };
    case PDF_FORM_SUBMISSION_CREATED:
      return { ...state, submissionCreated: payload };
    case PDF_FORM_SUBMISSION_EMAILED:
      return { ...state, submissionEmailed: payload };
    case PDF_FORM_SUBMISSION_DELETED:
      return { ...state, submissionDeleted: payload };
    default:
      return state;
  }
};
